// import { Button, Form, Switch } from 'antd';
// import React from 'react'
// import Modal from 'react-bootstrap/Modal';
// import { InputField } from '../../layouts/FormFields';

// const AddAffiliateParent = ({show,handleClose=()=>{}}) => {
//   return (
//     <>
//       {/* Modal for Show Partner Stores */}
//       <Modal show={show} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Add FAQ Category</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form name='basic' autoComplete='off' className='row p-5 px-3 pb-1'>
//             <div className='row'>
//               <InputField
//                 col='col-12'
//                 rules={[
//                   {
//                     required: true,
//                     message: 'Enter Name',
//                   },
//                 ]}
//                 placeholder='FAQ Name'
//                 name='name'
//                 label='Name'
//                 required={true}
//                 // onKeyPress={handleKeysPress}
//               />
//               <InputField
//                 col='col-12'
//                 rules={[
//                   {
//                     required: true,
//                     message: 'Enter Index',
//                   },
//                 ]}
//                 placeholder='Index'
//                 name='index'
//                 label='Index'
//                 required={true}
//                 // onKeyPress={handleKeysPress}
//               />
//               <div className='col-lg-12 mb-2 ms-3'>
//                 <Form.Item label='Active' className='selector-main' colon={false} valuePropName='checked' name='isActive'>
//                   <Switch
//                   // onChange={(e) => {
//                   //   console.log(e);
//                   //   setisActiv(e);
//                   // }}
//                   />
//                 </Form.Item>
//               </div>
//               <div className='d-flex align-items-center justify-content-center'>
//                 <button onClick={() => setUploadedImg('')} style={{ backgroundColor: 'rgb(242, 29, 47)' }} className='add-btn'>
//                   Add
//                 </button>
//               </div>
//             </div>
//           </Form>
//         </Modal.Body>

//       </Modal>
//     </>
//   );
// }

// export default AddAffiliateParent

import { Button, Form, message, Select, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { InputField, InputMasker, SelectField, SelectFields } from '../../layouts/FormFields';
import axios from 'axios';
import getHeaders from '../../utils/authHeaders';
import LoaderImage from '../LoaderImage';
import { app } from '../../config';
import { LoadingOutlined } from '@ant-design/icons';

const AddAffiliateParent = ({ show, setShow, handleClose = () => {}, setisRender, loader, setLoader }) => {
  const [form] = Form.useForm();
   const [phoneNumber, setPhoneNumber] = useState();
  
  const submit = async (values) => {
    try {
        let resp = await axios.post(`${app.URL}/api/v1/admin/affiliateparent/create`, values, { headers: getHeaders() });
      // let resp = await axios.post(`http://localhost:3200/api/v1/admin/affiliateparent/create`, values, { headers: getHeaders() });

      console.log(resp);
      if (resp.status == 200) {
        form.resetFields(); // Reset form fields after successful submission
        // setLoader(true);

        setShow(false); // Close modal
        // setisRender(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onFinish = (values) => {
      console.log("values", values)
       if (phoneNumber.length < 12) {
            //   setShow(false);
              message.error('Invalid mobile number');
              // message.error('Invalid mobile number')
              return;
            }
      submit({
        name: values.name ? values.name.trim() : null,
        contact: values.contact ? values.contact.split('_')[0].slice(0, 12) : '',
        email: values.email ? values.email: null,
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Form Submission Failed:', errorInfo);
  };
  // const getParents = async () => {
  //   try {
  //     let resp = await axios.get(`http://localhost:3200/api/v1/admin/faqparent/listing`);
  //     console.log('response', resp?.data?.result?.data);
  //     if (resp.status == 200) {
  //       setParentElemments(resp?.data?.result?.data);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // useEffect(() => {
  //   getParents();
  // }, []);
  const staticElements = [
    { faqparentCategoryId: 1, categoryName: 'Category 1' },
    { faqparentCategoryId: 2, categoryName: 'Category 2' },
  ];
  const handleChange = (event) => {
    setPhoneNumber(event.target.value);
  };
//   console.log('parentElements', parentElements);
  return (
    <>
      {/* {loader && <LoaderImage />} */}
      {/* {!loader && ( */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Affiliate Parent </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            form={form}
            name='basic'
            initialValues={{
              ['isActive']: 1,
            }}
            autoComplete='off'
            className='row  px-3 pb-1'
            onFinish={onFinish} // This will handle form submission
            onFinishFailed={onFinishFailed} // This will handle form validation failure
          >
            <div className='row'>
              {/* <div className='form-flo/ating'> */}
              <Form.Item
                colon={false}
                className=''
                rules={[
                  { required: true, message: 'Please enter  parent name.' }, // Validation rule to prevent empty submission
                ]}
              >
                <InputField
                  col='col-12'
                rules={[
                             {
                               required: true,
                               message: 'Enter Contact Name',
                               validator: (_, value) => {
                                 // Trim the value to remove spaces
                                 const trimmedValue = value?.trim();
               
                                 // Check if the trimmed value is empty
                                 if (!trimmedValue) {
                                   return Promise.reject('Contact Name is required');
                                 }
               
                                 // If value exists, allow the validation to pass
                                 return Promise.resolve();
                               },
                             },
                           ]}
                  placeholder='Parent Name'
                  name='name'
                  label='Parent Name'
                  required={true}
                />
              </Form.Item>
              <Form.Item
                colon={false}
                className=''
                rules={[
                  { required: true, message: 'Please enter a parent email.' }, // Validation rule to prevent empty submission
                ]}
              >
                <InputField
                  col='col-12'
                  type='email'
                  rules={[
                    {
                      required: true,
                      message: ' Enter Email',
                    },
                  ]}
                  placeholder='Enter Email '
                  name='email'
                  label='Enter Email '
                  required={true}
                />
              </Form.Item>
              <Form.Item
                colon={false}
                className=''
                // rules={[
                //   { required: true, message: 'Please enter a parent contact.' }, // Validation rule to prevent empty submission
                // ]}
              >
                <InputMasker
                  col='col-lg-12 col-md-12 col-12'
                  handleChange={handleChange}
                  rules={[
                    {
                      required: true,
                      message: 'Enter Mobile',
                    },
                  ]}
                  placeholder='Enter Mobile'
                  name='contact'
                  label='Mobile'
                  required={true}
                />
                
                {/* <InputField
                  col='col-12'
                //   rules={[
                //     {
                //       required: true,
                //       message: ' Enter Contact',
                //     },
                //   ]}
                  placeholder='Contact '
                  name='contact'
                  label='Contact '
                //   required={true}
                /> */}
              </Form.Item>

              {/* <div className='col-lg-12 mb-2 ms-3'>
                <Form.Item label='Active' className='selector-main' colon={false} valuePropName='checked' name='isActive'>
                  <Switch />
                </Form.Item>
              </div> */}
              <div className='col-12'>
                <div className='row justify-content-center'>
                  <button onClick={() => setShow(false)} htmlType='button' type='primary' className='btn btn-primary button patient-cancel-btn col-md-5 mr-2 mb-2'>
                    Cancel
                  </button>

                  <button disabled={loader} type='primary' class='btn btn-primary button col-md-5 mb-2' htmlType='submit'>
                    {loader ? <LoadingOutlined /> : 'Save'}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* )} */}
    </>
  );
};

export default AddAffiliateParent;
